import React, { useEffect, useState } from "react";
import { ValidateResponse, getCurrentPage, setCurrentPage } from "../../helpers/global";
import { fetchRentalCases } from "../../helpers/management";
import { List } from "../../../components/List";
import { ListPagination } from "../../../components/List/Pagination";
import { Message } from "../../../components/Message";
import { ContentGenerateExcel } from "../../../components/Content/GenerateExcel";
import { ContentWrapper } from "../../../components/Content/Wrapper";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AppManagementOverviewsActiverental({ current, identifier, filterValues, setFilterFields }) {

    let pageSize = 10; // default values ergens globaal opslaan?
    const [cases, setCases] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadFilters, setLoadFilters] = useState(true);
    const [pageNr, setPageNr] = useState(getCurrentPage(current));
    const [totalCount, setTotalCount] = useState(0);
    const [error, setError] = useState();
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem("filters" + identifier)));
    const [filterString, setFilterString] = useState("{}");
    const [documentName, setDocumentName] = useState();

    if (JSON.stringify(filterValues) !== filterString) {
        setFilterString(JSON.stringify(filterValues));
        setIsLoaded(false);
        setFilters(filterValues);
        setCurrentPage(1, current, setPageNr);
    }

    if (pageNr !== getCurrentPage(current)) {
        setPageNr(getCurrentPage(current));
    }

    const handlePagination = (page) => {
        setCurrentPage(page, current, setPageNr);
    }


    let listColumns = [
        { key: "displayName", type: "link", path: "", hideView: "large" }, //0
        { key: "rentalCaseId", label: "Dossiernr.", type: "text" },//1
        { key: "displayName", label: "Artikelnaam", type: "text", hideView: 'small' },//2
        { key: "startDate", label: "Startdatum", type: "date" },//3
        { key: "endDate", label: "Einddatum", type: "date" },//4
        { key: "departmentRoom", label: "Afdeling/ kamernr.", type: "text" },
        { key: "endUser", label: "Eindgebruiker", type: "text" },
        { key: "contact", label: "Contactpersoon", type: "text" },
        { key: "companyName", label: "Locatie", type: "text" }
    ];

    const defineFilterFields = () => {
        // The filters are set here and send to parent onloaded
        let filterFields = {
            location: { type: 'location', label: { locationId: "Verhuurlocatie", departmentId: "Afdeling" } },
        };

        setFilterFields(filterFields);
    }

    useEffect(() => {

        async function fetchData() {

            const callData = {
                filters: {
                    tabType: current,
                    limitOffset: pageSize * pageNr - (pageSize - 1),
                    limitRows: pageSize,
                    ...filters
                }
            }

            callData.filters.type = 'ACTIVE';

            await fetchRentalCases(callData).then((res) => {

                const response = ValidateResponse(res.data, 'cases');
                if (response.status === 'success') {

                    if (response.totalCount !== undefined) {
                        setTotalCount(response.totalCount);
                    }
                    setCases(response.cases);
                    setDocumentName(response.documentName);
                    setIsLoaded(true);

                    if (loadFilters !== current) {
                        defineFilterFields();
                        setLoadFilters(current);
                    }
                }
                else {
                    setError(response.message);
                }
            }).catch((error) => {
                const response = ValidateResponse(error);
                setError(response.message);
            });
        }

        fetchData();
    }, [current, pageNr, filters, filterString, pageSize]);

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (cases === undefined || cases === null || Object.keys(cases).length === 0) {
        return (<Message type="noData" />);
    }

    const excelbutton = () => {
        return <ContentGenerateExcel
            documentType={'rental'}
            filters={filters}
            display={'button-download'}
            fileName={documentName}
            mimeType={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
            label={'Download excel'}
        />
    }

    return (
        <>
            <ContentWrapper type='page-component' className="floating-button" content={excelbutton()} />
            <List
                columns={listColumns}
                data={cases}
                identifier={identifier}
            />

            <div className={'spacer'}></div>

            <ListPagination
                currentPage={pageNr}
                setCurrentPage={handlePagination}
                totalCount={totalCount}
                pageSize={pageSize}
            />
            <div style={{ height: '30px' }}></div>
        </>
    );
}